export default "__VITE_ASSET__DMOyro50__"